function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _check_private_redeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) {
        throw new TypeError("Cannot initialize the same private elements twice on an object");
    }
}
function _class_apply_descriptor_get(receiver, descriptor) {
    if (descriptor.get) {
        return descriptor.get.call(receiver);
    }
    return descriptor.value;
}
function _class_apply_descriptor_set(receiver, descriptor, value) {
    if (descriptor.set) {
        descriptor.set.call(receiver, value);
    } else {
        if (!descriptor.writable) {
            throw new TypeError("attempted to set read only private field");
        }
        descriptor.value = value;
    }
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _class_extract_field_descriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to " + action + " private field on non-instance");
    }
    return privateMap.get(receiver);
}
function _class_private_field_get(receiver, privateMap) {
    var descriptor = _class_extract_field_descriptor(receiver, privateMap, "get");
    return _class_apply_descriptor_get(receiver, descriptor);
}
function _class_private_field_init(obj, privateMap, value) {
    _check_private_redeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function _class_private_field_set(receiver, privateMap, value) {
    var descriptor = _class_extract_field_descriptor(receiver, privateMap, "set");
    _class_apply_descriptor_set(receiver, descriptor, value);
    return value;
}
function _class_private_method_get(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return fn;
}
function _class_private_method_init(obj, privateSet) {
    _check_private_redeclaration(obj, privateSet);
    privateSet.add(obj);
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { constructTheme } from "../../styles/theme/themeFactory";
import { DatasetComponent, TooltipComponent } from "echarts/components";
import { init, registerTheme, use } from "echarts/core";
import { SVGRenderer } from "echarts/renderers";
var CHART_ANCHOR_ELEMENT_SELECTOR = /.*(data-attr-anchor=true).*/i;
var _options = /*#__PURE__*/ new WeakMap(), _theme = /*#__PURE__*/ new WeakMap(), _instance = /*#__PURE__*/ new WeakMap(), _instanceId = /*#__PURE__*/ new WeakMap(), _eventCallbacks = /*#__PURE__*/ new WeakMap(), _containerElement = /*#__PURE__*/ new WeakMap(), _registerLifeCycleCallbacks = /*#__PURE__*/ new WeakSet(), _registerEventCallbacks = /*#__PURE__*/ new WeakSet(), _initResizeHandler = /*#__PURE__*/ new WeakSet(), _removeEventCallbacks = /*#__PURE__*/ new WeakSet(), _registerTheme = /*#__PURE__*/ new WeakSet();
/**
 * Represents an ECharts instance.
 */ export var Chart = /*#__PURE__*/ function() {
    "use strict";
    function Chart(theme, param) {
        var _param_extensions = param.extensions, extensions = _param_extensions === void 0 ? [] : _param_extensions, eventCallbacks = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
        _class_call_check(this, Chart);
        _class_private_method_init(this, _registerLifeCycleCallbacks);
        _class_private_method_init(this, _registerEventCallbacks);
        _class_private_method_init(this, _initResizeHandler);
        _class_private_method_init(this, _removeEventCallbacks);
        _class_private_method_init(this, _registerTheme);
        _class_private_field_init(this, _options, {
            writable: true,
            value: void 0
        });
        _class_private_field_init(this, _theme, {
            writable: true,
            value: void 0
        });
        _class_private_field_init(this, _instance, {
            writable: true,
            value: void 0
        });
        _class_private_field_init(this, _instanceId, {
            writable: true,
            value: void 0
        });
        _class_private_field_init(this, _eventCallbacks, {
            writable: true,
            value: void 0
        });
        _class_private_field_init(this, _containerElement, {
            writable: true,
            value: void 0
        });
        /**
   * @protected
   */ _define_property(this, "_anchorElementStyle", {
            opacity: 0,
            height: 0,
            width: 0,
            position: 'bottom',
            align: 'center'
        });
        _class_private_method_get(this, _registerTheme, registerTheme1).call(this, theme);
        _class_private_field_set(this, _eventCallbacks, eventCallbacks);
        use([
            TooltipComponent,
            DatasetComponent,
            SVGRenderer
        ].concat(_to_consumable_array(extensions)));
    }
    _create_class(Chart, [
        {
            key: "options",
            get: function get() {
                return _class_private_field_get(this, _options);
            },
            set: function set(opts) {
                _class_private_field_set(this, _options, opts);
            }
        },
        {
            key: "theme",
            get: function get() {
                return _class_private_field_get(this, _theme);
            }
        },
        {
            key: "instance",
            get: function get() {
                return _class_private_field_get(this, _instance);
            }
        },
        {
            key: "id",
            get: function get() {
                return _class_private_field_get(this, _instanceId);
            }
        },
        {
            key: "containerElement",
            get: function get() {
                return _class_private_field_get(this, _containerElement);
            }
        },
        {
            /**
   * Mounts EChart chart instance to specify HTML element.
   */ key: "mountInstance",
            value: function mountInstance(el, lifeCycleEvents) {
                if (!el) throw new Error('Element is not defined');
                _class_private_field_set(this, _containerElement, el);
                _class_private_field_set(this, _instance, init(el, _class_private_field_get(this, _theme)._name, {
                    renderer: 'svg'
                }));
                if (lifeCycleEvents === null || lifeCycleEvents === void 0 ? void 0 : lifeCycleEvents.rendered) {
                    _class_private_method_get(this, _registerLifeCycleCallbacks, registerLifeCycleCallbacks).call(this, 'rendered', lifeCycleEvents.rendered);
                }
                if (lifeCycleEvents === null || lifeCycleEvents === void 0 ? void 0 : lifeCycleEvents.finished) {
                    _class_private_method_get(this, _registerLifeCycleCallbacks, registerLifeCycleCallbacks).call(this, 'finished', lifeCycleEvents.finished);
                }
                this.instance.setOption(_class_private_field_get(this, _options));
                _class_private_field_set(this, _instanceId, this.instance.id);
                _class_private_method_get(this, _initResizeHandler, initResizeHandler).call(this);
                _class_private_method_get(this, _registerEventCallbacks, registerEventCallbacks).call(this);
            }
        },
        {
            /**
   * Removes EChart chart instance from DOM and any event listeners that were associated with it.
   */ key: "disposeInstance",
            value: function disposeInstance() {
                if (!this.instance) return;
                this.instance.dispose();
                this.clearResizeHandler();
                _class_private_method_get(this, _removeEventCallbacks, removeEventCallbacks).call(this);
            }
        },
        {
            /**
   * Toggles Chart loading animation on. Used loading animation is defined in the chart theme._loading.
   */ key: "showLoading",
            value: function showLoading() {
                this.instance.showLoading('default', this.theme._components.loading);
            }
        },
        {
            /**
   * Toggles Chart loading animation off.
   */ key: "hideLoading",
            value: function hideLoading() {
                this.instance.hideLoading();
            }
        },
        {
            /**
   * Forces Chart instance to resize.
   */ key: "resizeChart",
            value: function resizeChart() {
                this.instance.resize({
                    width: 'auto',
                    height: 'auto'
                });
            }
        },
        {
            /**
   * Removes Chart instance Window resize event listener.
   */ key: "clearResizeHandler",
            value: function clearResizeHandler() {
                var _this = this;
                window.removeEventListener('resize', function() {
                    return _this.instance.resize();
                });
            }
        },
        {
            /**
   * Applies specified options to Chart instance.
   */ key: "applyOptions",
            value: function applyOptions(opts) {
                _class_private_field_set(this, _options, _object_spread({}, _class_private_field_get(this, _options), opts));
                this.instance.setOption(_class_private_field_get(this, _options), {
                    notMerge: false
                });
            }
        },
        {
            /**
   * Adjusts the dimensions of the container element, and resize the Chart instance.
   * @protected
   */ key: "_adjustContainerDimensions",
            value: function _adjustContainerDimensions(dimensions) {
                if (Object.hasOwn(dimensions, 'height')) {
                    this.containerElement.style.height = "".concat(dimensions.height, "px");
                }
                if (Object.hasOwn(dimensions, 'width')) {
                    this.containerElement.style.width = "".concat(dimensions.width, "px");
                }
                this.resizeChart();
            }
        },
        {
            /**
   * Parses `containerElement` child `text` elements which contain inner text that matches the pattern
   * defined in `ANCHOR_ELEMENT_SELECTOR`. Parsed text will be added to selected elements' data attributes.
   * The selected elements' inner text will be set to `null` once it has been parsed and added
   * to the elements' data attributes.
   * @protected
   */ key: "_parseTextDataAttributes",
            value: function _parseTextDataAttributes() {
                Array.from(this.containerElement.querySelectorAll('text')).filter(function(el) {
                    return el.innerHTML.match(CHART_ANCHOR_ELEMENT_SELECTOR);
                }).forEach(function(d) {
                    var textDataAttributes = d.innerHTML.split(',');
                    textDataAttributes.forEach(function(pair) {
                        var _pair_split = _sliced_to_array(pair.split('='), 2), attr = _pair_split[0], value = _pair_split[1];
                        if (!attr || !value) return;
                        d.setAttribute(attr, value);
                    });
                    d.innerHTML = null;
                });
            }
        },
        {
            /**
   * Generates a string based on specified data. String will be formatted as `"data-<key>=<data[key]>"`.
   * Useful when used in conjunction with `Chart._parseTextDataAttributes` to produce data attributes
   * for SVG text elements.
   * @protected
   */ key: "_formatDataAttribute",
            value: function _formatDataAttribute(data) {
                var _this_instance;
                return Object.keys(data).reduce(function(prev, cur) {
                    return "data-".concat(cur, "=").concat(data[cur], ",").concat(prev);
                }, "data-attr-anchor=true,echarts-instance-id=".concat((_this_instance = this.instance) === null || _this_instance === void 0 ? void 0 : _this_instance.id));
            }
        }
    ]);
    return Chart;
}();
/**
   * Provides helper functions for common Chart events.
   */ _define_property(Chart, "event", {
    /**
     * Helper function to create chart hover events.
     */ onHover: function(param) {
        var _param_query = param.query, query = _param_query === void 0 ? 'series' : _param_query, callback = param.callback;
        return {
            event: 'mouseover',
            query: query,
            cb: callback ? function(params) {
                return callback(params);
            } : null
        };
    },
    /**
     * Helper function to create chart click events.
     */ onClick: function(param) {
        var _param_query = param.query, query = _param_query === void 0 ? 'series' : _param_query, callback = param.callback;
        return {
            event: 'click',
            query: query,
            cb: callback ? function(params) {
                return callback(params);
            } : null
        };
    }
});
function registerLifeCycleCallbacks(event, cb) {
    _class_private_field_get(this, _instance).on(event, cb);
}
function registerEventCallbacks() {
    var _this = this;
    _class_private_field_get(this, _eventCallbacks).forEach(function(param) {
        var _param_event = param.event, event = _param_event === void 0 ? 'click' : _param_event, _param_query = param.query, query = _param_query === void 0 ? 'series' : _param_query, _param_cb = param.cb, cb = _param_cb === void 0 ? function(p) {
            return p;
        } : _param_cb;
        _this.instance.on(event, query, function(params) {
            return cb(params);
        });
    });
}
function initResizeHandler() {
    var _this = this;
    window.addEventListener('resize', function() {
        return _this.instance.resize();
    });
}
function removeEventCallbacks() {
    var _this = this;
    _class_private_field_get(this, _eventCallbacks).forEach(function(param) {
        var _param_event = param.event, event = _param_event === void 0 ? 'click' : _param_event, _param_cb = param.cb, cb = _param_cb === void 0 ? function(p) {
            return p;
        } : _param_cb;
        _this.instance.off(event, function(params) {
            return cb(params);
        });
    });
}
function registerTheme1(theme) {
    _class_private_field_set(this, _theme, constructTheme(theme));
    registerTheme(theme._name, theme);
}

//# sourceMappingURL=Chart.js.map